// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
    baseUrl: `${string}://${string}` | string & {};
};

export type AuthenticateRequest = {
    authCode?: string | null;
    codeVerifier?: string | null;
    password?: string | null;
    provider: string;
    username?: string | null;
};

export type AuthenticateResponse = {
    userId: string;
};

export type AuthorizeOAuth2Request = {
    clientId: string;
    codeChallenge?: string | null;
    codeChallengeMethod?: OpenIdConnectCodeChallengeMethod;
    nonce?: string | null;
    redirectUri: string;
    responseType: OAuth2ResponseType;
    scope: string;
    state?: string | null;
};

export type AuthorizeOAuth2Response = {
    redirect: AuthorizeRedirect;
};

export type AuthorizeRedirect = {
    redirectUri: string;
    isLogin: boolean;
    isConsent: boolean;
    isExternal: boolean;
};

export type BeffeAnonymousDirectTestingOnlyRequest = {
    [key: string]: never;
};

export type BeffeAnonymousTestingOnlyRequest = {
    [key: string]: never;
};

export type BeffeHMacDirectTestingOnlyRequest = {
    [key: string]: never;
};

export type BeffeTestingOnlyResponse = {
    callerId: string;
};

export type ConsentOAuth2ClientRequest = {
    consented: boolean;
    redirectUri: string;
    scope: string;
    state?: string | null;
};

export type ConsentOAuth2ClientResponse = {
    redirect: ConsentRedirect;
};

export type ConsentRedirect = {
    redirectUri: string;
    isConsented: boolean;
};

export type EmptyResponse = {
    [key: string]: never;
};

export type FeatureFlag = {
    isEnabled: boolean;
    name: string;
};

export type GetAllFeatureFlagsResponse = {
    flags: Array<FeatureFlag>;
};

export type GetFeatureFlagResponse = {
    flag: FeatureFlag;
};

export type HealthCheckResponse = {
    name: string;
    status: string;
};

export type LogoutRequest = {
    [key: string]: never;
};

export const OAuth2ResponseType = {
    CODE: 'code',
    ID_TOKEN: 'id_Token',
    TOKEN: 'token'
} as const;

export type OAuth2ResponseType = typeof OAuth2ResponseType[keyof typeof OAuth2ResponseType];

export const OpenIdConnectCodeChallengeMethod = { PLAIN: 'plain', S256: 's256' } as const;

export type OpenIdConnectCodeChallengeMethod = typeof OpenIdConnectCodeChallengeMethod[keyof typeof OpenIdConnectCodeChallengeMethod];

export type ProblemDetails = {
    type: string;
    title: string;
    status?: number;
    detail: string;
    instance: string;
    [key: string]: unknown | string | number | undefined;
};

export type RecordCrashRequest = {
    message: string;
};

export type RecordMeasureRequest = {
    additional?: {
        [key: string]: unknown;
    } | null;
    eventName: string;
};

export type RecordPageViewRequest = {
    path: string;
};

export type RecordTraceRequest = {
    arguments?: {
        [key: string]: unknown;
    } | null;
    level: string;
    messageTemplate: string;
};

export type RecordUseRequest = {
    additional?: {
        [key: string]: unknown;
    } | null;
    eventName: string;
};

export type RefreshTokenRequest = {
    [key: string]: never;
};

export type AuthenticateData = {
    body?: AuthenticateRequest;
    path?: never;
    query?: never;
    url: '/api/auth';
};

export type AuthenticateErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * The user's credentials are invalid
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * When the user has authenticated with credentials, but has MFA enabled. The details of the error contains a value of "mfa_required".
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * When the user has authenticated with credentials, but has not yet verified their registration
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * The user's account is suspended or disabled, and cannot be authenticated or used
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type AuthenticateError = AuthenticateErrors[keyof AuthenticateErrors];

export type AuthenticateResponses = {
    /**
     * Created
     */
    201: AuthenticateResponse;
};

export type AuthenticateResponse2 = AuthenticateResponses[keyof AuthenticateResponses];

export type LogoutData = {
    body?: LogoutRequest;
    path?: never;
    query?: never;
    url: '/api/auth/logout';
};

export type LogoutErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type LogoutError = LogoutErrors[keyof LogoutErrors];

export type LogoutResponses = {
    /**
     * Created
     */
    201: EmptyResponse;
};

export type LogoutResponse = LogoutResponses[keyof LogoutResponses];

export type RefreshTokenData = {
    body?: RefreshTokenRequest;
    path?: never;
    query?: never;
    url: '/api/auth/refresh';
};

export type RefreshTokenErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * The refresh token has expired
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * The user's account is suspended or disabled, and cannot be authenticated or used
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type RefreshTokenError = RefreshTokenErrors[keyof RefreshTokenErrors];

export type RefreshTokenResponses = {
    /**
     * Created
     */
    201: EmptyResponse;
};

export type RefreshTokenResponse = RefreshTokenResponses[keyof RefreshTokenResponses];

export type GetAllFeatureFlagsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/flags';
};

export type GetAllFeatureFlagsErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type GetAllFeatureFlagsError = GetAllFeatureFlagsErrors[keyof GetAllFeatureFlagsErrors];

export type GetAllFeatureFlagsResponses = {
    /**
     * OK
     */
    200: GetAllFeatureFlagsResponse;
};

export type GetAllFeatureFlagsResponse2 = GetAllFeatureFlagsResponses[keyof GetAllFeatureFlagsResponses];

export type GetFeatureFlagForCallerData = {
    body?: never;
    path: {
        Name: string;
    };
    query?: never;
    url: '/api/flags/{Name}';
};

export type GetFeatureFlagForCallerErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type GetFeatureFlagForCallerError = GetFeatureFlagForCallerErrors[keyof GetFeatureFlagForCallerErrors];

export type GetFeatureFlagForCallerResponses = {
    /**
     * OK
     */
    200: GetFeatureFlagResponse;
};

export type GetFeatureFlagForCallerResponse = GetFeatureFlagForCallerResponses[keyof GetFeatureFlagForCallerResponses];

export type HealthCheckData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/health';
};

export type HealthCheckErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type HealthCheckError = HealthCheckErrors[keyof HealthCheckErrors];

export type HealthCheckResponses = {
    /**
     * OK
     */
    200: HealthCheckResponse;
};

export type HealthCheckResponse2 = HealthCheckResponses[keyof HealthCheckResponses];

export type GetErrorData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/error';
};

export type GetErrorResponses = {
    /**
     * OK
     */
    200: unknown;
};

export type AuthorizeOAuth2Data = {
    body?: AuthorizeOAuth2Request;
    path?: never;
    query?: never;
    url: '/api/oauth2/authorize';
};

export type AuthorizeOAuth2Errors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type AuthorizeOAuth2Error = AuthorizeOAuth2Errors[keyof AuthorizeOAuth2Errors];

export type AuthorizeOAuth2Responses = {
    /**
     * Created
     */
    201: AuthorizeOAuth2Response;
};

export type AuthorizeOAuth2Response2 = AuthorizeOAuth2Responses[keyof AuthorizeOAuth2Responses];

export type ConsentOAuth2ClientData = {
    body?: ConsentOAuth2ClientRequest;
    path: {
        Id: string;
    };
    query?: never;
    url: '/api/oauth2/clients/{Id}/consent';
};

export type ConsentOAuth2ClientErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type ConsentOAuth2ClientError = ConsentOAuth2ClientErrors[keyof ConsentOAuth2ClientErrors];

export type ConsentOAuth2ClientResponses = {
    /**
     * Created
     */
    201: ConsentOAuth2ClientResponse;
};

export type ConsentOAuth2ClientResponse2 = ConsentOAuth2ClientResponses[keyof ConsentOAuth2ClientResponses];

export type RecordCrashData = {
    body?: RecordCrashRequest;
    path?: never;
    query?: never;
    url: '/api/record/crash';
};

export type RecordCrashErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type RecordCrashError = RecordCrashErrors[keyof RecordCrashErrors];

export type RecordCrashResponses = {
    /**
     * Created
     */
    201: EmptyResponse;
};

export type RecordCrashResponse = RecordCrashResponses[keyof RecordCrashResponses];

export type RecordMeasureData = {
    body?: RecordMeasureRequest;
    path?: never;
    query?: never;
    url: '/api/record/measure';
};

export type RecordMeasureErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type RecordMeasureError = RecordMeasureErrors[keyof RecordMeasureErrors];

export type RecordMeasureResponses = {
    /**
     * Created
     */
    201: EmptyResponse;
};

export type RecordMeasureResponse = RecordMeasureResponses[keyof RecordMeasureResponses];

export type RecordPageViewData = {
    body?: RecordPageViewRequest;
    path?: never;
    query?: never;
    url: '/api/record/page_view';
};

export type RecordPageViewErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type RecordPageViewError = RecordPageViewErrors[keyof RecordPageViewErrors];

export type RecordPageViewResponses = {
    /**
     * Created
     */
    201: EmptyResponse;
};

export type RecordPageViewResponse = RecordPageViewResponses[keyof RecordPageViewResponses];

export type RecordTraceData = {
    body?: RecordTraceRequest;
    path?: never;
    query?: never;
    url: '/api/record/trace';
};

export type RecordTraceErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type RecordTraceError = RecordTraceErrors[keyof RecordTraceErrors];

export type RecordTraceResponses = {
    /**
     * Created
     */
    201: EmptyResponse;
};

export type RecordTraceResponse = RecordTraceResponses[keyof RecordTraceResponses];

export type RecordUseData = {
    body?: RecordUseRequest;
    path?: never;
    query?: never;
    url: '/api/record/use';
};

export type RecordUseErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type RecordUseError = RecordUseErrors[keyof RecordUseErrors];

export type RecordUseResponses = {
    /**
     * Created
     */
    201: EmptyResponse;
};

export type RecordUseResponse = RecordUseResponses[keyof RecordUseResponses];

export type BeffeAnonymousDirectTestingOnlyData = {
    body?: BeffeAnonymousDirectTestingOnlyRequest;
    path?: never;
    query?: never;
    url: '/api/testingonly/direct/anonymous';
};

export type BeffeAnonymousDirectTestingOnlyErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type BeffeAnonymousDirectTestingOnlyError = BeffeAnonymousDirectTestingOnlyErrors[keyof BeffeAnonymousDirectTestingOnlyErrors];

export type BeffeAnonymousDirectTestingOnlyResponses = {
    /**
     * Created
     */
    201: BeffeTestingOnlyResponse;
};

export type BeffeAnonymousDirectTestingOnlyResponse = BeffeAnonymousDirectTestingOnlyResponses[keyof BeffeAnonymousDirectTestingOnlyResponses];

export type BeffeAnonymousTestingOnlyData = {
    body?: BeffeAnonymousTestingOnlyRequest;
    path?: never;
    query?: never;
    url: '/api/testingonly/anonymous';
};

export type BeffeAnonymousTestingOnlyErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type BeffeAnonymousTestingOnlyError = BeffeAnonymousTestingOnlyErrors[keyof BeffeAnonymousTestingOnlyErrors];

export type BeffeAnonymousTestingOnlyResponses = {
    /**
     * Created
     */
    201: BeffeTestingOnlyResponse;
};

export type BeffeAnonymousTestingOnlyResponse = BeffeAnonymousTestingOnlyResponses[keyof BeffeAnonymousTestingOnlyResponses];

export type BeffeHMacDirectTestingOnlyData = {
    body?: BeffeHMacDirectTestingOnlyRequest;
    path?: never;
    query?: never;
    url: '/api/testingonly/direct/hmac';
};

export type BeffeHMacDirectTestingOnlyErrors = {
    /**
     * Bad Request: The server cannot or will not process the request due to something that is perceived to be a client error
     */
    400: ProblemDetails;
    /**
     * Unauthorized: The client must authenticate itself to get the requested response
     */
    401: unknown;
    /**
     * Payment Required: The client must have payment information to get the requested response
     */
    402: unknown;
    /**
     * Forbidden: The client does not have access rights to the content; that is, it is unauthorized, so the server is refusing to give the requested resource
     */
    403: unknown;
    /**
     * Not Found: The server cannot find the requested resource
     */
    404: unknown;
    /**
     * Method Not Allowed: The request is not allowed by the current state of the resource
     */
    405: unknown;
    /**
     * Conflict: The request conflicts with the current state of the resource
     */
    409: unknown;
    /**
     * Locked: The current resource is locked and cannot be accessed
     */
    423: unknown;
    /**
     * Internal Server Error: An unexpected error occured on the server, which should not have happened in normal operation
     */
    500: ProblemDetails;
};

export type BeffeHMacDirectTestingOnlyError = BeffeHMacDirectTestingOnlyErrors[keyof BeffeHMacDirectTestingOnlyErrors];

export type BeffeHMacDirectTestingOnlyResponses = {
    /**
     * Created
     */
    201: BeffeTestingOnlyResponse;
};

export type BeffeHMacDirectTestingOnlyResponse = BeffeHMacDirectTestingOnlyResponses[keyof BeffeHMacDirectTestingOnlyResponses];
